import React from "react";
// import { getSubscriptionStatus, getDaysLeft } from "./PDSubscriptionUtils";

export default function PDSubscriptionCard({ data, index, onClick }) {
    const status = data.subscriptionStatus;
    const daysLeft = data.getDaysLeft;

    const statusColor =
        status === "ACTIVE"
            ? "text-green-400"
            : status === "EXPIRED"
                ? "text-red-400"
                : status === "UPCOMING"
                    ? "text-yellow-400"
                    : "text-gray-400";

    return (
        <div
            onClick={onClick}
            className="bg-[#111827] border border-gray-800 rounded-xl p-3 mb-3 cursor-pointer active:scale-[0.98] transition"
        >
            <div className="flex justify-between items-center">
                <div>
                    <div className="text-xs text-gray-200">
                        #{index + 1}
                    </div>
                    <div className="text-sm font-semibold text-cyan-400">
                        {data.subscriptionId}
                    </div>
                </div>
                <div className={`text-xs font-bold ${statusColor}`}>
                    {status}
                </div>
            </div>

            <div className="mt-2 text-xs text-gray-100">
                Product:{" "}
                {data.product}
            </div>
            <div className="mt-2 text-xs text-gray-100">
                Purchased:{" "}
                {new Date(data.paymentDate).toLocaleDateString()}
            </div>
            <div className="text-xs text-gray-100">
                Expires:{" "}
                {new Date(data.endDate).toLocaleDateString()}
            </div>

            {status === "ACTIVE" && (
                <div className="mt-2 text-xs text-yellow-300">
                    {daysLeft} days remaining
                </div>
            )}
        </div>
    );
}